/**
 * Rangepicker component entry
 * @author name
 */

import component from './component.js';

'use strict';

export default angular.module('Rangepicker', [])
  .component('bpRangepicker', component);



/** WEBPACK FOOTER **
 ** ./src/components/rangepicker/index.js
 **/